import axios from '../axios/axios';
import {
  AVOCATION_QUESTIONS_DATA_REQUEST,
  AVOCATION_QUESTIONS_DATA_SUCCESS,
  AVOCATION_QUESTIONS_DATA_FAIL,
} from '../constants/avocationConstants';

export const avocationAction = () => async (dispatch) => {
  try {
    dispatch({ type: AVOCATION_QUESTIONS_DATA_REQUEST });
    const { data } = await axios.post('/rpiq-form-fetch', {
      section: 'f1v1s16',
      form_id: localStorage.getItem('formId'),
    });

    dispatch({
      type: AVOCATION_QUESTIONS_DATA_SUCCESS,
      payload: data,
    });
  } catch (error) {
    if (
      error?.response?.status === 401 ||
      error?.response?.detail === 'Not authenticated'
    ) {
      window.location.replace('/');
    }
    dispatch({
      type: AVOCATION_QUESTIONS_DATA_FAIL,
      payload: error,
    });
  }
};
